/* unplugin-vue-components disabled */import script from "./AuthUploader.vue?vue&type=script&lang=tsx&setup=true"
export * from "./AuthUploader.vue?vue&type=script&lang=tsx&setup=true"

import "./AuthUploader.vue?vue&type=style&index=0&id=3dacd9de&lang=css"
import "./AuthUploader.vue?vue&type=style&index=1&id=3dacd9de&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dacd9de"]])

export default __exports__